import { createSelector } from 'redux-starter-kit';
const draggedItemSelector = (state: any) => state.dragAndDrop;

export const dragAndDropSelectors = {
  getDraggedItem: createSelector(draggedItemSelector, subState => {
    return subState.draggedItem;
  })
};
